import React from 'react';
import PropTypes from 'prop-types';
import QuizEditorHeader from './nodes/QuizEditorHeader';

import {
  ActivityEditorContainer,
  ActivityEditorSection,
  ActivityEditorSectionHeader,
  EditorHeaderRow,
  ActivityEditor,
  ActivityEditorArea,
  ButtonWrapper,
  Editor,
  PreviewText,
} from './styles';

const NodeActivityEditor = ({
  type,
  index = 0,
  legacyContent,
  removeLegacyMedia,
  headerPanel,
  headerRightPanel,
  headerText,
  editorPanel,
  editorText,
  sneakPeakPanel,
  buttonPanel,
  disabled,
  ...rest
}) => {
  const headerSection = () => {
    const getHeaderComponent = () => {
      switch (type) {
        case 'written_quiz':
        case 'quiz':
          return QuizEditorHeader;
        default:
          return EditorHeaderRow;
      }
    };
    const HeaderComponent = getHeaderComponent();

    return (
      <HeaderComponent
        index={index}
        headerRightPanel={headerRightPanel}
        headerText={headerText}
        legacyContent={legacyContent}
        removeLegacyMedia={removeLegacyMedia}
      >
        {headerPanel}
      </HeaderComponent>
    );
  };

  return (
    <ActivityEditorContainer className={'ir-content'}>
      <ActivityEditorSection>
        <ActivityEditorSectionHeader disabled={disabled} {...rest}>
          {headerSection()}
        </ActivityEditorSectionHeader>
        <ActivityEditor disabled={disabled} {...rest}>
          <ActivityEditorArea>
            {editorPanel ? (
              editorPanel
            ) : (
              <Editor className="content-section">
                <PreviewText dangerouslySetInnerHTML={{ __html: editorText || '' }} />
              </Editor>
            )}
          </ActivityEditorArea>
          {sneakPeakPanel}
        </ActivityEditor>
      </ActivityEditorSection>
      {buttonPanel && <ButtonWrapper className={'ir-hide'}>{buttonPanel}</ButtonWrapper>}
    </ActivityEditorContainer>
  );
};

export default NodeActivityEditor;

NodeActivityEditor.propTypes = {
  type: PropTypes.string.isRequired,
  index: PropTypes.number,
  legacyContent: PropTypes.object,
  removeLegacyMedia: PropTypes.func,
  headerPanel: PropTypes.object,
  headerRightPanel: PropTypes.object,
  headerText: PropTypes.string,
  editorPanel: PropTypes.object,
  editorText: PropTypes.string,
  sneakPeakPanel: PropTypes.object,
  buttonPanel: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  disabled: PropTypes.bool,
};
